import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { TrpcInputs } from '../../config/trpc';
import { getDifferences } from '../../utils/findChangedKeys';

export type QuoteForm = Partial<NonNullable<TrpcInputs['updateQuote']>>;
export type UseQuoteForm = { methods: UseFormReturn<QuoteForm> };
type Options = { isCreate: boolean };

const defaultOptions = { isCreate: false };

const validationSchema = z.object({
  provider_id: z.string().nullish(),
  expires_at: z.coerce.date().nullish(),
  cutoff_at: z.coerce.date().nullish(),
  chargeable_weight: z.coerce.number().nullish(),
  estimated_transit_time: z.string().nullish(),
  status: z.string().nullish(),
  is_fastest: z.boolean().nullish(),
  pickup_ref: z.string().nullish(),
  estimated_pickup_at: z.coerce.date().nullish(),
});
export const useQuoteForm = (data?: QuoteForm, { isCreate }: Options = defaultOptions): UseQuoteForm => {
  const methods = useForm<QuoteForm>({
    mode: 'onBlur',
    resolver: zodResolver(validationSchema),
    defaultValues: data,
  });

  const { getValues, setValue } = methods;

  useEffect(() => {
    const updateFields = () => {
      const changes = getDifferences<QuoteForm>(getValues(), data);
      if (!changes.length) return;

      for (const [key, value] of changes) {
        if (value !== undefined) setValue<any>(key, value);
      }
    };

    // Run if we're not on create & we have data
    if (!isCreate && data) updateFields();
  }, [data, getValues, setValue, isCreate]);

  return { methods: { ...methods, getValues, setValue } };
};
